import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
const notifications = [['Mariana', 'México'], ['Valentina', 'Colombia'], ['Sofía', 'Argentina'], ['Elena', 'España'], ['Camila', 'Chile']] as const;
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    if (closed) return;
    const show = window.setTimeout(() => setVisible(true), 4500);
    const rotate = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex(current => (current + 1) % notifications.length);
        setVisible(true);
      }, 450);
    }, 10000);
    return () => {
      window.clearTimeout(show);
      window.clearInterval(rotate);
    };
  }, [closed]);
  const [name, country] = notifications[index];
  return <AnimatePresence data-id="element-18">
      {visible && !closed && <motion.aside initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 18
    }} role="status" className="fixed bottom-4 left-4 z-50 flex max-w-[calc(100vw-2rem)] items-start gap-3 border border-[#d2b171] bg-[#fffaf0] p-3 pr-9 shadow-xl" data-id="element-19">
          <CheckCircle2Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-[#7a5b20]" data-id="element-20" />
          <p className="text-sm leading-5 text-[#243147]" data-id="element-21">
            <strong data-id="element-22">{name}</strong> de {country} acaba de acceder al libro
            digital.
          </p>
          <button type="button" aria-label="Cerrar notificación" onClick={() => setClosed(true)} className="absolute right-2 top-2 rounded p-1 text-[#687080] hover:bg-[#eee4d1] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#7a5b20]" data-id="element-23">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}